import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class FinancialBonusCouponType extends ApiBase {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/bonus/couponType`)
  }
}
